import styled from 'styled-components';

export const Description = styled.span`
	font-size: 0.6rem;
	font-weight: 400;
`;

export const Score = styled.span`
	font-size: 0.75rem;
	font-weight: 600;
`;
